import React from "react";
import { MaximizeIcon, MinimizeIcon } from "lucide-react";
import { CloseIcon } from "@cmp-src/icons/icons";
import { useAskTessa } from "@cmp-src/tessa/AskTessaProvider";

export const ChatButtonActions: React.FC = () => {
  const askTessa = useAskTessa();

  return (
    <div className={"flex gap-2"}>
      <button
        className="flex items-center gap-2"
        onClick={() => askTessa?.isPopup.toggle()}
      >
        {askTessa?.isPopup?.state ? (
          <MaximizeIcon className={"size-6"} />
        ) : (
          <MinimizeIcon className={"size-6"} />
        )}
      </button>
      <button
        className="flex items-center gap-2"
        onClick={() => askTessa?.tessaDisclosure.close()}
      >
        <CloseIcon className={"size-6"} />
      </button>
    </div>
  );
};
